import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NestedTreeControl } from "@angular/cdk/tree";
import {MatTreeNestedDataSource,} from "@angular/material/tree";
import { Subject } from 'rxjs';

@Component({
  selector: "app-sales-trends-popup-info",
  templateUrl: "./sales-trends-popup-info.component.html",
  styleUrls: ["./sales-trends-popup-info.component.scss"],
})
export class SalesTrendsPopupInfoComponent implements OnInit,OnDestroy {
  title: string;
  showToolTip: any;
  hasChild: any;
  private destroy$ = new Subject<void>();

  private _transformer = (node: any, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      value: node.value,
      type: node.type,
    };
  };
  treeControl = new NestedTreeControl<any>(node => node.children);
  dataSource = new MatTreeNestedDataSource<any>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<SalesTrendsPopupInfoComponent>
  ) {}
  ngOnDestroy(): void {
    this.dialogRef.close();
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.hasChild = (_: number, node: any) => !!node.children && node.children.length > 0;
    this.title = this.data.title;
    this.showToolTip = this.data.data;
    this.getDataSourceByTitle();
  }
  close() {
    this.dialogRef.close();
  }

  getDataSourceByTitle() {
    switch (this.data.title) {
      case "Revenue":
        this.getRevenues();
        break;
      case "Refund":
        this.getRefunds();
        break;
      case "Orders":
        this.getOrders();
        break;
      case "Sales Fees":
        this.getSaleFees();
        break;
      case "Other Fees":
        this.getOtherFees();
        break;
      case "Sales COGS":
        this.getSalesCOGS();
        break;
      case "Profit":
        this.getProfit();
        break;
        case "Profit last 30 days":
          this.getProfit();
          break;
      case "COGS":
        this.getCogs();
        break;
      case "Fees":
        this.getFees();
        break;
      case "PPC":
        this.getPpc();
        break;
      default:
        return "";
    }
  }
  getRevenues() {
    const revenueData = [
      {
        name: "Organic sale",
        value: Number(this.showToolTip.organicRevenue),
        type: "currency",
        children: [],
      },
      {
        name: "PPC sale",
        value: Number(this.showToolTip.ppcRevenue),
        type: "currency",
        children: [],
      },
    ];
    this.dataSource.data = revenueData;
  }

  getRefunds() {
    const refunData = [
      {
        name: "Qty Returned",
        value: this.showToolTip.returnPctOfSales,
        type: "percentage",
        children: [
          {
            name: "Fulfillable",
            value: Number(this.showToolTip.returnSellablePctOfSales),
            type: "percentage",
            pieces: Number(this.showToolTip.qtyReturnedSellable),
          },
          {
            name: "Unfulfillable",
            value: Number(this.showToolTip.returnNotSellablePctOfSales),
            type: "percentage",
            pieces: Number(this.showToolTip.qtyReturnedUnSellable),
          },
        ],
      },
      {
        name: "Refund",
        value: this.showToolTip.refund,
        type: "currency",
        children: [
          {
            name: "Fulfillable",
            value: Number(this.showToolTip.refundSellable),
            type: "currency",
          },
          {
            name: "Unfulfillable",
            value: Number(this.showToolTip.refundUnSellable),
            type: "currency",
          },
        ],
      },
    ];
    this.dataSource.data = refunData;
  }

  getOrders() {
    const ordersData = [
      {
        name: "Orders",
        value: this.showToolTip.orders,
        children: [
          { name: "Organic", value: Number(this.showToolTip.organicOrders) },
          { name: "PPC ", value: Number(this.showToolTip.ppcOrders) },
        ],
      },
      {
        name: "Unit sold",
        value: this.showToolTip.unitSold,
        children: [
          { name: "Organic", value: Number(this.showToolTip.organicUnitSold) },
          { name: "PPC ", value: Number(this.showToolTip.ppcUnitSold) },
        ],
      },
    ];
    this.dataSource.data = ordersData;
  }

  getSaleFees() {
    const salesFeesData = [
      {
        name: "Commission fee",
        value: Number(this.showToolTip.commissionFees),
        type: "currency",
      },
      {
        name: "fulfillment Fees",
        value: Number(this.showToolTip.fulfillmentFees),
        type: "currency",
      },
    ];
    this.dataSource.data = salesFeesData;
  }

  getOtherFees() {
    const otherFeesData = [
      {
        name: "Storage fee",
        value: Number(this.showToolTip.storageFees),
        type: "currency",
      },
      {
        name: "Promotion fee",
        value: Number(this.showToolTip.promotionFees),
        type: "currency",
      },
      {
        name: "Delivery fee",
        value: Number(this.showToolTip.deliveryFees),
        type: "currency",
      },
    ];
    this.dataSource.data = otherFeesData;
  }

  getSalesCOGS() {
    const salesCOGSData = [
      {
        name: "Organic COGS",
        value: Number(this.showToolTip.organicCogs),
        type: "currency",
        revenusData: this.showToolTip.cogsPctOfRevenue,
      },
      {
        name: "PPC COGS",
        value: Number(this.showToolTip.ppcCogs),
        type: "currency",
      },
    ];
    this.dataSource.data = salesCOGSData;
  }

  getProfit() {
    const totalFees = Math.abs(this.showToolTip.commissionFees) + Math.abs(this.showToolTip.deliveryFees) + Math.abs(this.showToolTip.fulfillmentFees) 
    + Math.abs(this.showToolTip.otherFees) + Math.abs(this.showToolTip.promotionFees) + Math.abs(this.showToolTip.salesFees);
    const profitData = [
      {
        name: "Sales",
        value: Number(this.showToolTip.revenue),
        type: "currency",
        children: [
          { name: "Organic", value: Number(this.showToolTip.organicRevenue) },
          { name: "PPC", value: Number(this.showToolTip.ppcRevenue) },
        ],
      },
      {
        name: "Advertising cost",
        value: Number(this.showToolTip.ppcSpent),
        type: "currency",
      },
      {
        name: "Refund cost",
        value: Number(this.showToolTip.returnCogs),
        type: "currency",
      },
      {
        name: "Amazon fees",
        value: Number(this.showToolTip.salesFees),
        type: "currency",
         children: [
          {
            name: "Commission Fees",
            value: Number(Math.abs(this.showToolTip.commissionFees)),
          },
          {
            name: "Delivery Fees",
            value: Number(Math.abs(this.showToolTip.deliveryFees)),
          },

          {
            name: "Fulfillment Fees",
            value: Number(Math.abs(this.showToolTip.fulfillmentFees)),
          },
          {
            name: "Promotion",
            value: Number(Math.abs(this.showToolTip.promotionFees)),
          },
          {
            name: "Other",
            value: Number(Math.abs(this.showToolTip.otherFees)),
          },
        ],
      },
      {
        name: "Cost of goods",
        value: Number(this.showToolTip.salesCogs),
        type: "currency",
        children: [
          { name: "Organic", value: Number(this.showToolTip.organicCogs) },
          { name: "PPC", value: Number(this.showToolTip.ppcCogs) },
        ],
      },
      {
        name: "Gross profit",
        value: Number((this.showToolTip.salesProfit) || 0),
        type: "currency",
      },
      {
        name: "Net profit",
        value: Number((this.showToolTip.profit) || 0),
        type: "currency",
      },
      {
        name: "Orders",
        hasGrayClass:true,
        value: this.showToolTip.orders,
        children :[
          {
            name: "Organic",
            hasGrayClass:true,
            value: Number(this.showToolTip.organicOrders),
            type: "currency",
            children: [],
          },
          {
            name: "PPC",
            hasGrayClass:true,
            value: Number(this.showToolTip.ppcOrders),
            type: "currency",
            children: [],
          },
        ]
      },
      {
        name: "Unit Sold",
        hasGrayClass:true,
        value: this.showToolTip.unitSold,
        children :[
          {
            name: "Organic",
            hasGrayClass:true,
            value: Number(this.showToolTip.organicUnitSold),
            type: "currency",
            children: [],
          },
          {
            name: "PPC",
            hasGrayClass:true,
            value: Number(this.showToolTip.ppcUnitSold),
            type: "currency",
            children: [],
          },
        ]
      },
      {
        name: "Real ACOS",
        hasGrayClass:true,
        value: Number(this.showToolTip.ppcAcos),
      },
      {
        name: "% Refunds",
        hasGrayClass:true,
        value: Number(this.showToolTip.refund),
      },
      {
        name: "Sellable returns",
        hasGrayClass:true,
        value: Number(this.showToolTip.returnPctOfSales),
      },
      {
        name: "Margin",
        hasGrayClass:true,
        value: Number(this.showToolTip.margin),
      },
      {
        name: "ROI",
        hasGrayClass:true,
        value: Number(this.showToolTip.cogsPctOfRevenue),
      },
    ];
    this.dataSource.data = profitData;
  }

  getCogs() {
    const cogsData = [
      {
        name: "Sales COGS",
        value: Number(this.showToolTip.salesCogs),
        type: "currency",
        revenusData: Number(this.showToolTip.cogsPctOfRevenue),
        children: [
          {
            name: "Organic COGS",
            value: Number(this.showToolTip.organicOrders),
            type: "currency",
          },
          {
            name: "PPC COGS",
            value: Number(this.showToolTip.ppcOrders),
            type: "currency",
          },
        ],
      },
      {
        name: "Return COGS",
        value: Number(this.showToolTip.returnCogs),
        type: "currency",
      },
    ];
    this.dataSource.data = cogsData;
  }

  getFees() {
    const FeesData = [
      {
        name: "Sales Fees",
        value: Number(this.showToolTip.salesFees),
        type: "currency",
        revenusData: Number(this.showToolTip.feesPctOfRevenue),
        children: [
          {
            name: "Commission fee",
            value: Number(this.showToolTip.commissionFees),
            type: "currency",
          },
          {
            name: "Referral fee",
            value: Number(this.showToolTip.fulfillmentFees),
            type: "currency",
          },
        ],
      },
      {
        name: "Other Fees",
        value: Number(this.showToolTip.otherFees),
        type: "currency",
        children: [
          {
            name: "Promotion fee",
            value: Number(this.showToolTip.promotionFees),
            type: "currency",
          },
          {
            name: "Delivery fee",
            value: Number(this.showToolTip.deliveryFees),
            type: "currency",
          },
        ],
      },
    ];
    this.dataSource.data = FeesData;
  }

  getPpc() {
    const ppcData = [
      {
        name: "Spent",
        value: Number(this.showToolTip.ppcSpent),
        type: "currency",
      },
      {
        name: "ACOS",
        value: Number(this.showToolTip.ppcAcos),
        type: "currency",
      },
      {
        name: "TACOS",
        value: Number(this.showToolTip.ppcTacos),
        type: "currency",
      },
    ];
    this.dataSource.data = ppcData;
  }
}
